import Plot from 'react-plotly.js';
import * as Plotly from 'plotly.js';
import _ from 'lodash';
import { chartTypeMap, ColorData } from '../../utils/constants';
import { abbreviateNumber } from '../../utils/utils';

export default function TextInfo({
  barWidthValue,
  barData,
  axisKeys,
  height,
  type
}: {
  barWidthValue: number;
  // barData: BarChartDetails;
  barData: any;
  axisKeys: { key: string; alias: string; color: string }[];
  height: number;
  // eslint-disable-next-line react/require-default-props
  type?: string;
}) {
  const yAxis: string[] = [];
  // const xAxis: {label : string; value: number}[] = [];
  const xAxis: number[] | any = [];
  const txt: string[] = [];
  axisKeys
    .slice()
    .reverse()
    .forEach((axisData) => {
      xAxis.push(barData[axisData.key]);
      yAxis.push(axisData.key);
      txt.push(`${axisData.alias}`);
    });

  return (
    !_.isEmpty(barData) && (
      <div className='info-details-container'>
        <div
          className='info-details'
          style={{ color: ColorData.darkgreyColor }}
        >
          {abbreviateNumber(barData.currency_label, barData.current, 1)}
        </div>
        <div className='info-details' style={{ color: ColorData.primaryColor }}>
          {abbreviateNumber(barData.currency_label, barData.new, 1)}
        </div>
      </div>
    )
  );
}
